module.exports = "/_next/static/images/search-d8abf66b8dfa62bf8cbaf5dcb92141cb.svg";